import jwt_decode from "jwt-decode";
import axios from "axios";

export const checkToken = () => {
    const token: any = localStorage.getItem('token')
    const decoded: any = jwt_decode(token || '')
    const exp :any = decoded.exp
    const date = Math.floor(Date.now() / 1000)
    const diffDate = date - exp
    // console.log(exp, date,diffDate)
}

export const isExpiredToken = () => {
    const token: any = localStorage.getItem('token')
    const decoded: any = jwt_decode(token)
    const date: any = new Date()
    const currentDate: any = Math.round(date / 1000)
    if(currentDate > decoded.exp){
        localStorage.removeItem('token')
    }
}